import { User } from "firebase/auth";
import { apiFetch } from "./client";

export interface ArchiveStandingRow {
  rank: number;
  displayName: string;
  score: number;
  isTied: boolean;
  userId: string | null;
}

export interface ArchivePayload {
  standings: ArchiveStandingRow[];
}

export interface LeagueArchiveSummary {
  id: string;
  name: string;
  modeLabel: string;
  competitionName: string;
  season: string;
  finishedAt: string;
  payload: ArchivePayload;
}

export function fetchArchives(user: User): Promise<LeagueArchiveSummary[]> {
  return apiFetch(user, "/archives");
}
